module.exports = __webpack_public_path__ + "images/admin-acae6151.svg";